import { createFileRoute, Outlet } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated')({
    beforeLoad: async ({ location, context }) => {
        const { auth } = context;

        if (!auth?.getValue("isAuthenticated")) {
            throw redirect({
                to: "/login",
                search: {
                    redirect: location.href,
                },
            });
        }
    },
    component: AuthenticatedLayoutComponent,
})

function AuthenticatedLayoutComponent() {
    return (
        <div className="container mx-auto max-w-3xl p-2">
            <Outlet />
        </div>
    );
}
